import React, { useEffect, useContext, useState, useRef } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TypingStatus from "./TypingStatus";
import { SocketContext } from "../../context/socket";
import { getUserFromLocalStorage } from "../../utils/localStorage";
import api from "../../utils/axios";
import { shouldSendOnKey, shouldCancelOnKey } from "../../utils/composer";
import {
  CHAT_CUTOFF,
  API_URL,
  MESSAGE_TYPE,
  ROLE,
  STATUS,
} from "../../constants/constants";
import { useTranslation } from "react-i18next";
import {
  addMessage,
  updateMessage,
  updateEditMessage,
} from "../../redux/messageSlice";
import { addOthersUnread, newMessage } from "../../redux/taskSlice";
import FullScreenImage from "./FullScreenImage";
import "../../assets/css/MessageInput.css";
import FullScreenImageEditor from "./FullScreenImageEditor.js";
import { setNew } from "../../redux/messageInputSlice";
import { showApiError } from "../../utils/apiError";
import { uploadToS3, IMAGE, FILE } from "../../utils/upload";

window.Buffer = window.Buffer || require("buffer").Buffer;

let timeout;

export default function MessageInputBox() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [user, setUser] = useState({});
  // const room = useSelector((state) => state.chat.currentTask);
  const task = useSelector((state) => state.current);
  const tasks = useSelector((state) => state.task);
  const messageInput = useSelector((state) => state.messageInput);
  // One Enter press can arrive as two keydown events, and a double tap on the
  // send button is two taps. React state cannot stop either: setMessage has not
  // re-rendered by the time the second one runs, so both read the same text and
  // both post it. A ref is read and written in the same tick.
  const sending = useRef(false);
  const textField = useRef(null);

  const socket = useContext(SocketContext);

  const [lineCount, setLineCount] = useState(1);
  const [message, setMessage] = useState("");
  const [filesList, setFilesList] = useState([]);
  const [previewFilesList, setPreviewFilesList] = useState([]);
  const [typing, setTyping] = useState(false);
  const [progress, setProgress] = useState(100);
  const [latestMessage, setLatestMessage] = useState();
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [imageIndex, setImageIndex] = useState(0);
  const [fullScreenShow, setFullScreenShow] = useState(false);
  const [fullScreenEditShow, setFullScreenEditShow] = useState(false);
  const maxRow = 9;
  const [uploadProgress, setUploadProgress] = useState();

  useEffect(() => {
    setFlag(!flag);
  }, [filesList]);

  useEffect(() => {
    textField.current.focus();
    // setMessage("");
    // setImageList([]);
    // setPreviewURL([]);
  }, [task]);

  useEffect(() => {
    socket.on("bot-message", (newTaskReceived) => {
      const user = getUserFromLocalStorage();
      console.log(`Bot Message : ${JSON.stringify(newTaskReceived)}`);

      // IF User is not client, then send bot message
      if (newTaskReceived.client != user._id) sendBotMessage(newTaskReceived);
    });

    return () => socket.removeListener("bot-message");
  }, []);

  // Set Name
  useEffect(() => {
    const user = getUserFromLocalStorage();
    setUser(user);
  }, []);

  useEffect(() => {
    setTyping(false);
    // tasks.forEach((task) => {
    //   socket.emit("stop-typing", {
    //     room: task._id,
    //     user: { _id: user._id, username: user.username },
    //   });
    // });
  }, [task]);

  useEffect(() => {
    if (messageInput.type == MESSAGE_TYPE.EDIT) {
      setMessage(messageInput.message);
      setFilesList([]);
      setPreviewFilesList([]);
    } else {
      initializeMessageInput();
    }
  }, [messageInput]);

  // useEffect(() => {
  //   const tempTask = tasks.filter((task) => task.taskname == room);
  //   const task = { ...tempTask[0] };

  //   // socket.emit("join", { name, room, task }, (error) => {
  //   //   if (error) {
  //   //     toast.error(error);
  //   //     // navigate("/");
  //   //   }
  //   // });
  // }, [room]);

  const initializeMessageInput = () => {
    // Clean messageinput
    setMessage("");
    setFilesList([]);
    setPreviewFilesList([]);
    setLineCount(1);
  };

  const sendBotMessage = async (newTaskReceived) => {
    const user = getUserFromLocalStorage();

    let username;
    const users = newTaskReceived.users;
    users.forEach((item) => {
      if (item._id != user._id) username = item.username;
    });

    const messages = [
      { message: `Hallo ${username},`, time: 5000 },
      { message: "ich bin Patrick von Codemenschen.", time: 3000 },
      {
        message:
          "Bitte füge alles zur Aufgabe in diesen Chat ein, mein Team und ich schätzen die Aufgaben gerne gleich für dich.",
        time: 4000,
      },
    ];

    socket.emit("typing", {
      room: newTaskReceived._id,
      user: { _id: user._id, username: user.username },
    });

    for (let i = 0; i < messages.length; i++) {
      await delaytimeout(messages[i].time);
      sendDelayedBotMessage(messages[i].message, newTaskReceived._id);
    }

    socket.emit("stop-typing", {
      room: newTaskReceived._id,
      user: { _id: user._id, username: user.username },
    });
  };

  const delaytimeout = (delay) => {
    return new Promise((res) => setTimeout(res, delay));
  };

  const onChange = (e) => {
    const text = e.target.value;

    textField.current.style.height = "auto";
    textField.current.style.height = e.target.scrollHeight + "px";

    // if (!text) textField.current.style.height = "27px";

    // const lineNumber = text.split(/\r*\n/).length;

    // // if (lineNumber == 1) textField.current.style.height = "25px";
    // if (lineNumber <= maxRow) setLineCount(lineNumber);
    setMessage(e.target.value);

    if (!typing) {
      setTyping(true);
      socket.emit("typing", {
        room: task._id,
        user: { _id: user._id, username: user.username },
      });
      timeout = setTimeout(timeoutFunction, 5000);
    } else {
      clearTimeout(timeout);
      timeout = setTimeout(timeoutFunction, 5000);
    }
  };

  const timeoutFunction = () => {
    setTyping(false);
    socket.emit("stop-typing", {
      room: task._id,
      user: { _id: user._id, username: user.username },
    });
  };

  const onKeyDown = (e) => {
    // shouldSendOnKey ignores the keydown an input method editor fires while it
    // is still composing, which otherwise sends the message a second time.
    if (shouldSendOnKey(e)) {
      e.preventDefault();
      sendMessage();
    }
    if (shouldCancelOnKey(e)) {
      e.preventDefault();
      cancelMessage();
    }
  };

  const sendDelayedBotMessage = async (message, taskId) => {
    const tempMessage = message;
    const userInfo = getUserFromLocalStorage();
    const data = {
      sender: userInfo,
      message: tempMessage,
      images: [],
      files: [],
      task: taskId,
      createdAt: new Date(),
    };

    setMessage("");
    // if (task._id == taskId) dispatch(addMessage(data));
    // dispatch(newMessage({ taskId: taskId, message: tempMessage }));

    // // Add others(except me and sender) message unread count
    // dispatch(
    //   addOthersUnread({
    //     taskId: taskId,
    //     userId: userInfo._id,
    //     senderId: userInfo._id,
    //   })
    // );

    await api
      .post(`${API_URL}/api/v1/message/send/`, {
        message: tempMessage,
        taskId: taskId,
      })
      .then((res) => {
        if (task._id == taskId) dispatch(addMessage(res.data));
        dispatch(newMessage({ taskId: taskId, message: res.data.message }));

        // Add others(except me and sender) message unread count
        dispatch(
          addOthersUnread({
            taskId: taskId,
            userId: userInfo._id,
            senderId: userInfo._id,
          }),
        );

        socket.emit("new-message", res.data);
        setLineCount(1);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          navigate("/");
        }

        showApiError(err);
      });
  };

  const sendMessage = () => {
    if (sending.current) return;
    sending.current = true;
    if (messageInput.type == MESSAGE_TYPE.NEW) sendNewMessage();
    else if (messageInput.type == MESSAGE_TYPE.EDIT) sendEditMessage();
    else if (messageInput.type == MESSAGE_TYPE.REPLY) sendReplyMessage();
    else sending.current = false;
  };

  const sendNewMessage = async () => {
    if (!message && filesList.length === 0) {
      sending.current = false;
      return;
    }
    {
      setTyping(false);
      socket.emit("stop-typing", {
        room: task._id,
        user: { _id: user._id, username: user.username },
      });
      const tempMessage = message;
      const tempFilesList = [...filesList];
      let imageList = [];
      let fileList = [];
      for (let i = 0; i < tempFilesList.length; i++) {
        if (tempFilesList[i].type === "image") {
          imageList.push(tempFilesList[i].url);
        } else
          fileList.push({
            filename: tempFilesList[i].filename,
            url: tempFilesList[i].url,
          });
      }

      const userInfo = getUserFromLocalStorage();

      // Message data
      const data = {
        sender: userInfo,
        message: tempMessage,
        images: imageList,
        files: fileList,
        task: task._id,
        createdAt: new Date(),
      };

      // After sent message, make input field clear
      setMessage("");
      setFilesList([]);
      setPreviewFilesList([]);
      setLineCount(1);

      // Add new message to message redux
      dispatch(addMessage(data));

      // Update task update time
      dispatch(newMessage({ taskId: task._id, message: tempMessage }));

      // Add others(except me and sender) message unread count
      dispatch(
        addOthersUnread({
          taskId: task._id,
          userId: userInfo._id,
          senderId: userInfo._id,
        }),
      );

      await api
        .post(`${API_URL}/api/v1/message/send/`, {
          message: tempMessage,
          images: imageList,
          files: fileList,
          taskId: task._id,
        })
        .then((res) => {
          dispatch(updateMessage(res.data));
          // After store message, emit message sent event
          socket.emit("new-message", res.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            navigate("/");
          }

          showApiError(err);
        });
      sending.current = false;

      // Back to auto, not to a number. The box grows by having its height set
      // to the content on every keystroke, and pinning it to 28px afterwards
      // left that number in the style attribute, so the field stayed a hard
      // 28px until the next keystroke measured it again.
      textField.current.style.height = "auto";
      // await api.post(`${API_URL}/api/v1/task/latestMessage/`, ${})

      // await api.post(`${API_URL}/api/v1/task/read/`,{taskId : task._id}).then(res => {

      // })
    }
  };

  const sendEditMessage = async () => {
    if (!message) {
      sending.current = false;
      return;
    }
    {
      setTyping(false);
      socket.emit("stop-typing", {
        room: task._id,
        user: { _id: user._id, username: user.username },
      });

      dispatch(
        updateEditMessage({
          id: messageInput.id,
          message: message,
        }),
      );

      dispatch(setNew());

      await api
        .post(`${API_URL}/api/v1/message/edit/`, {
          messageId: messageInput.id,
          message: message,
        })
        .then((res) => {
          // After store message, emit message sent event
          socket.emit("edit-message", res.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            navigate("/");
          }

          showApiError(err);
        });
      sending.current = false;
    }
  };

  const sendReplyMessage = async () => {
    if (!message && filesList.length === 0) {
      sending.current = false;
      return;
    }
    {
      setTyping(false);
      socket.emit("stop-typing", {
        room: task._id,
        user: { _id: user._id, username: user.username },
      });
      const tempMessage = message;
      const tempFilesList = [...filesList];
      let imageList = [];
      let fileList = [];
      for (let i = 0; i < tempFilesList.length; i++) {
        if (tempFilesList[i].type === "image") {
          imageList.push(tempFilesList[i].url);
        } else
          fileList.push({
            filename: tempFilesList[i].filename,
            url: tempFilesList[i].url,
          });
      }

      const userInfo = getUserFromLocalStorage();

      const messageId = messageInput.id;
      const replymessage = messageInput.message;

      // Message data
      const data = {
        sender: userInfo,
        message: tempMessage,
        images: imageList,
        files: fileList,
        task: task._id,
        replymessage: {
          id: messageId,
          message: replymessage,
        },
        replied: true,
        createdAt: new Date(),
      };

      dispatch(setNew());

      // Add new message to message redux
      dispatch(addMessage(data));

      // Update task update time
      dispatch(newMessage({ taskId: task._id, message: tempMessage }));

      // Add others(except me and sender) message unread count
      dispatch(
        addOthersUnread({
          taskId: task._id,
          userId: userInfo._id,
          senderId: userInfo._id,
        }),
      );

      await api
        .post(`${API_URL}/api/v1/message/reply/`, {
          message: tempMessage,
          images: imageList,
          files: fileList,
          taskId: task._id,
          messageId: messageId,
          replymessage: replymessage,
        })
        .then((res) => {
          dispatch(updateMessage(res.data));
          // After store message, emit message sent event
          socket.emit("new-message", res.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            navigate("/");
          }

          showApiError(err);
        });
      sending.current = false;

      // Back to auto, not to a number. The box grows by having its height set
      // to the content on every keystroke, and pinning it to 28px afterwards
      // left that number in the style attribute, so the field stayed a hard
      // 28px until the next keystroke measured it again.
      textField.current.style.height = "auto";
      // await api.post(`${API_URL}/api/v1/task/latestMessage/`, ${})

      // await api.post(`${API_URL}/api/v1/task/read/`,{taskId : task._id}).then(res => {

      // })
    }
  };

  const cancelMessage = () => {
    if (messageInput.type == MESSAGE_TYPE.NEW) {
      initializeMessageInput();
    } else if (messageInput.type == MESSAGE_TYPE.EDIT) dispatch(setNew());
    else if (messageInput.type == MESSAGE_TYPE.REPLY) dispatch(setNew());
  };

  const handleUploadClick = (e) => {
    e.preventDefault();
  };

  const handleUploadProgress = (e) => {
    setProgress(e.percent);
  };

  // const handleUploadSuccess = (body, file) => {
  //   // console.log(body, file);
  //   const filename = body;
  //   const tempImageList = [...imageList];
  //   tempImageList.push(filename);
  //   setImageList(tempImageList);
  //   // console.log(imageList);
  //   toast.success("Upload Success");
  //   setProgress(100);
  // };

  // const handleUploadError = (e, body) => {
  //   toast.error(body.error);
  //   const tempPreview = [...previewURL];
  //   tempPreview.splice(tempPreview.length - 1, 1);
  //   setPreviewURL(tempPreview);
  // };

  // const handleUploadStart = (file) => {
  //   const objectUrl = URL.createObjectURL(file);
  //   const tempPreviewUrl = [...previewURL];
  //   tempPreviewUrl.push(objectUrl);
  //   setPreviewURL(tempPreviewUrl);
  //   setProgress(0);
  // };

  const onDeleteImagesAndFiles = (index) => {
    // const tempPreviewUrl = [...previewURL];
    // tempPreviewUrl.splice(index, 1);
    // setPreviewURL(tempPreviewUrl);

    // const tempImageList = [...imageList];
    // tempImageList.splice(index, 1);
    // setImageList(tempImageList);
    const tempFilesList = [...filesList];
    tempFilesList.splice(index, 1);
    setFilesList(tempFilesList);

    const tempPreviewFilesList = [...previewFilesList];
    tempPreviewFilesList.splice(index, 1);
    setPreviewFilesList(tempPreviewFilesList);
  };

  const handleChange = async (e) => {
    const fileObject = e.target.files[0];

    if (fileObject.type.includes("image")) {
      const objectUrl = URL.createObjectURL(fileObject);
      const fileName = fileObject.name;
      // const tempPreviewUrl = [...previewURL];
      // tempPreviewUrl.push(objectUrl);
      // setPreviewURL(tempPreviewUrl);
      const tempPreviewFilesList = [...previewFilesList];
      const tempFile = {
        type: "image",
        previewurl: objectUrl,
        filename: fileName,
        url: "",
      };
      tempPreviewFilesList.push(tempFile);
      setPreviewFilesList(tempPreviewFilesList);
      setProgress(0);
      const edited = false;
      await uploadImageToS3(fileObject, tempFile, edited);
    } else {
      const fileName = fileObject.name;
      const tempPreviewFilesList = [...previewFilesList];
      const tempFile = {
        type: "file",
        filename: fileName,
        url: "",
      };
      tempPreviewFilesList.push(tempFile);
      setPreviewFilesList(tempPreviewFilesList);
      // const tempPreFileURL = [...preFileURL];
      // tempPreFileURL.push(fileName);
      // setPreFileURL(tempPreFileURL);
      setProgress(0);
      await uploadFileToS3(fileObject, tempFile);
    }
  };

  const handlePaste = async (e) => {
    if (e.clipboardData.files.length) {
      const fileObject = e.clipboardData.files[0];

      if (fileObject.type.includes("image")) {
        const objectUrl = URL.createObjectURL(fileObject);
        const fileName = fileObject.name;
        // const tempPreviewUrl = [...previewURL];
        // tempPreviewUrl.push(objectUrl);
        // setPreviewURL(tempPreviewUrl);
        const tempPreviewFilesList = [...previewFilesList];
        const tempFile = {
          type: "image",
          previewurl: objectUrl,
          filename: fileName,
          url: "",
        };
        tempPreviewFilesList.push(tempFile);
        setPreviewFilesList(tempPreviewFilesList);
        setProgress(0);
        const edited = false;
        await uploadImageToS3(fileObject, tempFile, edited);
      } else {
        const fileName = fileObject.name;
        const tempPreviewFilesList = [...previewFilesList];
        const tempFile = {
          type: "file",
          filename: fileName,
          url: "",
        };
        tempPreviewFilesList.push(tempFile);
        setPreviewFilesList(tempPreviewFilesList);
        // const tempPreFileURL = [...preFileURL];
        // tempPreFileURL.push(fileName);
        // setPreFileURL(tempPreFileURL);
        setProgress(0);
        await uploadFileToS3(fileObject, tempFile);
      }
    }
  };

  // Both of these post to our own API, which holds the AWS credentials and
  // puts the object in the same S3 bucket as before. What stood here built a
  // react-aws-s3 client in the browser out of config_image / config_file,
  // which meant the access key and the secret were in the bundle.
  //
  // The four Cloudinary functions that also lived here are gone: the only
  // calls to them had been commented out, and one of them was an empty
  // function body.

  const uploadFileToS3 = async (fileObject, tempFile) => {
    setProgress(0);
    try {
      const url = await uploadToS3(fileObject, {
        kind: FILE,
        fallbackName: tempFile?.filename,
        onProgress: setProgress,
      });
      tempFile.url = url;
      setFilesList([...filesList, tempFile]);
      toast.success("Upload Success");
      setProgress(100);
    } catch (err) {
      showApiError(err, "Uploading Failed!");
      const tempPreviewFilesList = [...previewFilesList];
      tempPreviewFilesList.splice(tempPreviewFilesList.length, 1);
      setPreviewFilesList(tempPreviewFilesList);
      setProgress(0);
    }
  };

  const uploadImageToS3 = async (fileObject, tempFile, edited) => {
    setProgress(0);
    try {
      const url = await uploadToS3(fileObject, {
        kind: IMAGE,
        fallbackName: tempFile?.filename,
        onProgress: setProgress,
      });
      tempFile.url = url;
      const tempFilesList = [...filesList];
      if (edited) tempFilesList[imageIndex] = tempFile;
      else tempFilesList.push(tempFile);
      setFilesList(tempFilesList);
      toast.success("Upload Success");
      setProgress(100);
    } catch (err) {
      showApiError(err, "Uploading Failed!");
      const tempPreviewFilesList = [...previewFilesList];
      // Drop the preview that will never get a URL. The edited case used to
      // pass imageIndex.length, which is undefined on a number, so splice was
      // called with undefined and removed the wrong entry.
      tempPreviewFilesList.splice(
        edited ? imageIndex : tempPreviewFilesList.length - 1,
        1,
      );
      setPreviewFilesList(tempPreviewFilesList);
      setProgress(0);
    }
  };

  const saveEditedImage = async (blob) => {
    const tempPreviewFilesList = [...previewFilesList];

    const objectUrl = URL.createObjectURL(blob);
    const fileName = tempPreviewFilesList[imageIndex].filename + "-edited";
    const tempFile = {
      type: "image",
      previewurl: objectUrl,
      filename: fileName,
      url: "",
    };
    tempPreviewFilesList[imageIndex] = tempFile;

    setPreviewFilesList(tempPreviewFilesList);
    setProgress(0);
    const edited = true;
    await uploadImageToS3(blob, tempFile, edited);
  };

  const cancelEdit = () => {
    dispatch(setNew());
  };

  const cancelReplyMessage = () => {
    dispatch(setNew());
  };

  // A finished task is settled and its chat is closed for the client. The team
  // keeps writing access so an admin can follow up or reopen the task.
  const CLOSED_FOR_CLIENT = [
    STATUS.PAID,
    STATUS.GETFEEDBACK,
    STATUS.REFUNDED,
    STATUS.PAID_DELETED,
    STATUS.DELETED,
    STATUS.ARCHIVED,
    STATUS.CLOSED,
  ];
  const me = getUserFromLocalStorage();
  // CLOSED holds for everyone, the team included. The other states here are
  // where the workflow ends up and leave the team able to follow up; this one
  // is a decision an admin made, and the way back is the reopen button.
  // A missing timestamp must not read as 1970 and therefore as closed: the
  // task-updated socket event carries no updatedTime, and that slim object can
  // reach the current task. Unknown means draw the box and let the server rule.
  const lastActivity = task?.updatedTime ? new Date(task.updatedTime) : null;
  if (
    Boolean(CHAT_CUTOFF && lastActivity && lastActivity < CHAT_CUTOFF) ||
    task?.status === STATUS.CLOSED ||
    (me?.role === ROLE.CLIENT && CLOSED_FOR_CLIENT.includes(task?.status))
  ) {
    return (
      <div className="message-input">
        <div className="chat-closed-note">{t("chat_closed")}</div>
      </div>
    );
  }

  return (
    <div className="message-input">
      <FullScreenImage
        image={image}
        fullScreenShow={fullScreenShow}
        setFullScreenShow={setFullScreenShow}
      />
      <FullScreenImageEditor
        image={image}
        fullScreenEditShow={fullScreenEditShow}
        setFullScreenEditShow={setFullScreenEditShow}
        saveEditedImage={saveEditedImage}
      />
      <TypingStatus />
      <hr />
      {messageInput.type == MESSAGE_TYPE.REPLY && (
        <>
          <div className="d-flex justify-content-between">
            <div>
              <i class="bi bi-arrow-return-left"></i>
            </div>
            <div
              className="flex-auto reply-message"
              dangerouslySetInnerHTML={{
                __html: messageInput.message.replace(/\r*\n/g, "<br/>"),
              }}
            ></div>
            <div>
              <button
                className="reply-message-cancel"
                onClick={cancelReplyMessage}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>

          <hr />
        </>
      )}
      {previewFilesList.length > 0 ? (
        <div className="image-input-pane">
          <div>
            <progress max="100" value={progress}></progress>
          </div>
          {previewFilesList.map((file, index) => (
            <>
              {file.type === "image" ? (
                <div className="d-inline-block position-relative">
                  <img
                    key={index}
                    className="image-input"
                    src={file.previewurl}
                    onClick={() => {
                      setImage(file.previewurl);
                      setFullScreenShow(true);
                    }}
                  />
                  <button
                    className="image-delete"
                    onClick={() => onDeleteImagesAndFiles(index)}
                  >
                    <i class="bi bi-x-circle-fill"></i>
                  </button>
                  <button
                    className="image-edit"
                    onClick={() => {
                      setImage(file.previewurl);
                      setImageIndex(index);
                      setFullScreenEditShow(true);
                    }}
                  >
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </div>
              ) : (
                <div className="d-inline-block position-relative">
                  <div key={index} className="file-input">
                    <div className="file-input-text">{file.filename}</div>
                  </div>
                  <button
                    className="image-delete"
                    onClick={() => onDeleteImagesAndFiles(index)}
                  >
                    <i class="bi bi-x-circle-fill"></i>
                  </button>
                </div>
              )}
            </>
          ))}
        </div>
      ) : (
        <></>
      )}

      <div className="d-flex align-items-end justify-content-between">
        <div>
          <label htmlFor="upload-button">
            <div
              className="d-flex justify-content-center blue-button text-white align-items-center text-centerr"
              style={{ cursor: "pointer" }}
            >
              <i className="bi bi-plus"></i>
            </div>
          </label>
          <input
            type="file"
            // accept="image/png, image/jpeg"
            id="upload-button"
            style={{ display: "none" }}
            onChange={handleChange}
          />
        </div>
        <textarea
          onPaste={handlePaste}
          ref={textField}
          value={message}
          rows={lineCount}
          placeholder="Type a message here"
          className="flex-auto"
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        <div className="d-flex align-items-center">
          {/* <button className="emoji-button">
            <i className="bi bi-emoji-smile"></i>
          </button> */}

          {messageInput.type === MESSAGE_TYPE.EDIT ? (
            <button
              className="blue-button text-white ms-2"
              onClick={cancelEdit}
            >
              <i class="bi bi-x-lg"></i>
            </button>
          ) : (
            <button
              className="blue-button text-white ms-2"
              onClick={sendMessage}
            >
              <i className="bi bi-cursor-fill"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
